import Api from './Api'
import moment from "moment";


export default {
  getavailabilities(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.3'
      }
    }
    const postData = {
      from_date: moment()
        .format("YYYY-MM-DD"),
      to_date: moment()
        .add(15, "months")
        .format("YYYY-MM-DD")
    }
    return Api().post('/availability/', postData, headerData)
  },
  getAvailability(authToken, fromDate, toDate, selectedUnit) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + authToken,
        Accept: 'application/json;version=1.3'
      }
    }
    const postData = {
      from_date: fromDate,
      to_date: toDate,
      unit: selectedUnit
    }
    return Api().post('/app/availability/', postData, headerData)
  }

}
